// extracted by mini-css-extract-plugin
module.exports = {"field":"sign-up-form_field__1CLSK","submit":"sign-up-form_submit__1gOAy"};